import {collection, component, field, identifier, LocalisableEntityData} from "@fedeltapointofsale/data-client";
import {MarkupData} from "../markup/markup.data";
import {SurchargeDiscountInteractionData} from "../interaction/surcharge-discount-iteraction.data";
import {PricingScheduleSummaryData} from "../pricing-schedule/pricing-schedule.data";
import {PeriodScheduleReferenceData} from "../../system/period-schedule/period-schedule.data";

export class SurchargeData extends LocalisableEntityData<SurchargeData> {
    @identifier surchargeId: number;
    @field name: string;
    @field amount: number;
    @field taxApplicable: boolean = true;
    @field description: string;
    @component modifier: MarkupData;
    @field discontinued: boolean;
    @collection(SurchargeDiscountInteractionData) discountInteractions: SurchargeDiscountInteractionData[];
    @collection(PeriodScheduleReferenceData) periodSchedules: PeriodScheduleReferenceData[];
}

export class SurchargeReferenceData extends LocalisableEntityData<SurchargeReferenceData> {
    @identifier surchargeId: number;
    @field name: string;
}
